var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 698,
    height: 698,
    viewBox: "0 0 698 698",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4067_172)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 349,
    r: 149,
    fill: "url(#paint0_linear_4067_172)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4067_172",
    x: 0,
    y: 0,
    width: 698,
    height: 698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_4067_172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4067_172",
    x1: 209.02,
    y1: 349,
    x2: 479.505,
    y2: 392.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseOrange);
export default __webpack_public_path__ + "static/media/ellipse-orange.f5ab706f7e8fb641ea394937be45e3b6.svg";
export { ForwardRef as ReactComponent };